<ngx-loading [show]="loading"></ngx-loading>
<div class="teal-background white-font header">
  <span class="text-uppercase">Style Colours</span>
</div>
<form [formGroup]="styleForm" class="border container flex-grow-1">
  <div class="row py-1 align-items-center">
    <div class="col-auto">
      <label class="style-label mb-0" for="primary">Primary</label>
    </div>
    <div class="col">
      <input type="color" id="primary" name="Primary" formControlName="portalColourPrimary" />
    </div>
  </div>
  <div class="row py-1 align-items-center grey-two-background">
    <div class="col-auto">
      <label class="style-label mb-0" for="secondary">Secondary</label>
    </div>
    <div class="col">
      <input type="color" id="secondary" name="Secondary" formControlName="portalColourSecondary" />
    </div>
  </div>
  <div class="row py-1 align-items-center">
    <div class="col-auto">
      <label class="style-label mb-0" for="accent">Accent</label>
    </div>
    <div class="col">
      <input type="color" id="accent" name="Accent" formControlName="portalColourAccent" />
    </div>
  </div>
  <div class="row py-1 align-items-center grey-two-background">
    <div class="col-auto">
      <label class="style-label mb-0" for="menuFont">Menu Font</label>
    </div>
    <div class="col">
      <input type="color" id="menuFont" name="Menu Font" formControlName="portalColourMenuFont" />
    </div>
  </div>
  <div class="row py-2 align-items-center">
    <div class="col">
      <div class="d-flex justify-content-end py-2">
        <button
          class="btn medium em-btn em-btn-green mr-2"
          type="button"
          (click)="updateSettings()"
          [disabled]="styleForm.pristine || styleForm.invalid"
        >
          <i class="far fa-save"></i> Save
        </button>
        <button
          class="btn medium em-btn em-btn-green"
          type="button"
          (click)="resetSettings()"
          [disabled]="styleForm.pristine"
        >
          <i class="far fa-minus-circle"></i> Cancel
        </button>
      </div>
    </div>
  </div>
</form>
